import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import { useExtensionContext } from "../ExtensionContext";
import EmptyStatus from "app/popleads/components/ui-kit/EmptyStatus";
import Spinner from "app/popleads/components/ui-kit/Spinner";
import { StyledImageBox } from "app/popleads/components/ui-kit/Card";
import useGetGptRecommendation from "app/popleads/hooks/useGetGptRecommendation";
import { StyledCardContent } from "./common/styled";
import { StyledNameTag } from "./ExtensionViewDeal";
import { nameTag } from "app/popleads/app/functions/util";
import { toast } from "react-toastify";
import Button from "app/popleads/components/ui-kit/Button";
import FeatherIcon from "feather-icons-react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Tabs from "app/popleads/components/ui-kit/Tabs";
import ExtensionAIAgentFeeds from "./ExtensionAIAgentFeeds";
import ExtensionCainNotifications from "./ExtensionCainNotifications";
import { ExtensionBody } from "app/popleads/components/ui-kit/Text";
import Switch from "app/popleads/components/ui-kit/Switch";
import useSetUserSettings from "app/popleads/hooks/useSetUserSettings";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/modules/Auth/_redux/authRedux";
import { get } from "app/popleads/networking/RequestService";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import ExtensionAIAssistantSettings from "./ExtensionAIAssistantSettings";

const ExtensionPopupContentBody = styled.div`
    width: 100%;
    // min-height: 100%;
    // max-height: 100%;
    padding: 0px 12px 12px 12px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    flex: 1;
`;

const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
`;

/*const EmailMessage = styled.div`
    background-color: white;
    border-radius: 6px;
    padding: 16px;
    border: 1px solid ${colors.neutral[200]};
    white-space: pre-line;
    color: ${colors.neutral[800]};
    font-size: 14px;
    line-height: 1.5;
`;*/

const ErrorMessage = styled.div`
    color: ${colors.danger[500]};
    text-align: center;
    padding: 20px;
    background-color: white;
    border-radius: 6px;
    margin: 20px 0;
`;

export const StyledCampaignLinkContent = styled(StyledCardContent)`
    color: ${(props) => colors.l3rnTech[900]};
`;

const CollapseCard = styled.div`
    background-color: white;
    border-radius: 8px;
    border: 1px solid ${colors.neutral[200]};
    margin-bottom: 12px;
    overflow: visible;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
`;

const CollapseHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    cursor: pointer;
    background-color: white;
    border-bottom: ${(props) => (props.isOpen ? `1px solid ${colors.neutral[200]}` : "none")};

    &:hover {
        background-color: ${colors.neutral[50]};
    }
`;

const CollapseContent = styled.div`
    padding: 8px;
    background-color: ${colors.neutral[25]};
    border-top: 1px solid ${colors.neutral[200]};
    width: 100%;
    box-sizing: border-box;
    min-height: auto;
`;

const MessageSection = styled.div`
    margin-bottom: 16px;
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;

    &:last-child {
        margin-bottom: 0;
    }
`;

const MessageLabel = styled.div`
    font-weight: 600;
    color: ${colors.neutral[700]};
    margin-bottom: 8px;
    font-size: 14px;
`;

const MessageContent = styled.div`
    background-color: white;
    border-radius: 6px;
    padding: 8px;
    border: 1px solid ${colors.neutral[200]};
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    color: ${colors.neutral[800]};
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    a {
        color: ${colors.l3rnTech[900]};
        text-decoration: underline;
        font-weight: 600;

        &:hover {
            color: ${colors.l3rnTech[900]};
        }
    }
`;

const CardHeader = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

const CardImage = styled.div`
    margin-right: 12px;
    flex-shrink: 0;
`;

const CardTitle = styled.div`
    flex: 1;
`;

const CollapseIcon = styled.div`
    margin-left: 12px;
    color: ${colors.neutral[500]};
    font-size: 16px;
    transition: transform 0.2s;
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledFooter = styled.div`
    padding: 12px;
    background-color: #fff;
`;

const ExtensionAIAssistantPage = () => {
    const { isProfileLoading, profile, isProfileNotFound } = useExtensionContext();
    const dispatch = useDispatch();
    const { user: loggedInUser } = useSelector((state) => state.auth);
    const {
        gptRecommendation,
        loading: gptRecommendationLoading,
        error: gptRecommendationError,
    } = useGetGptRecommendation(profile?.id);
    const [errorIndexes, setErrorIndexes] = useState([]);
    const [collapsedItems, setCollapsedItems] = useState({});

    const [selectedTab, setSelectedTab] = useState(!isProfileNotFound ? "Course Recommendations" : "AI Agent Feeds");
    const [aiSalesAgent, setAiSalesAgent] = useState(loggedInUser.isAiAgentEnabled === "1");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { setUserSettings, loading: userSettingsLoading } = useSetUserSettings({
        onSuccess: async () => {
            const { data } = await get("getLoggedinUser");
            dispatch(actions.setUser(data.user));
        },
        onError: () => {
            setAiSalesAgent(loggedInUser.isAiAgentEnabled === "1");
        },
    });

    const handleSetAiSalesAgent = () => {
        setAiSalesAgent((prev) => !prev);
        setUserSettings({ settingsKey: "isAiAgentEnabled", settingsValue: aiSalesAgent ? "0" : "1" });
    };

    const options = useMemo(
        () => [
            {
                value: "Course Recommendations",
                disabled: Boolean(isProfileNotFound),
                disabledMessage: "You need to open a profile to perform this action.",
            },
            { value: "AI Agent Feeds" },
            { value: "New Connections" },
        ],
        [isProfileNotFound]
    );

    const handleImageError = (index) => {
        setErrorIndexes((prev) => [...prev, index]);
    };

    const toggleCollapse = (courseId) => {
        setCollapsedItems((prev) => ({
            ...prev,
            [courseId]: !prev[courseId],
        }));
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success("Copied to clipboard");
        } catch (error) {
            toast.error("Failed to copy to clipboard");
        }
    };

    const stripHtmlTags = (html) => {
        if (!html) return "";

        let cleanText = html;
        const linkRegex = /<a[^>]+href=["']([^"']+)["'][^>]*>([^<]*)<\/a>/gi;
        const links = [];
        let match;
        while ((match = linkRegex.exec(html)) !== null) {
            const url = match[1];
            const text = match[2] || url;
            links.push(`${text}: ${url}`);
            cleanText = cleanText.replace(match[0], `LINK_PLACEHOLDER_${links.length - 1}`);
        }
        cleanText = cleanText
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"');
        links.forEach((link, index) => {
            cleanText = cleanText.replace(`LINK_PLACEHOLDER_${index}`, link);
        });

        return cleanText.trim();
    };

    const handleMessageClick = (event) => {
        if (event.target.tagName === "A") {
            event.preventDefault();
            window.open(event.target.href, "_blank", "noopener,noreferrer");
        }
    };

    const sendEmail = (message, courseName) => {
        if (!profile?.email && !profile?.email2) {
            toast.error("This profile has no email");
            return;
        }

        const recipient = profile?.email || profile?.email2;
        const subject = courseName ? `Course Recommendation: ${courseName}` : "Course Recommendation";
        const cleanMessage = stripHtmlTags(message);

        const body = encodeURIComponent(cleanMessage);
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${body}`;
        window.open(mailtoLink);
    };

    const renderCourseCard = (course, index) => {
        const courseKey = course.id || `course-${index}`;
        const isOpen = collapsedItems[courseKey] || false;

        return (
            <CollapseCard key={courseKey}>
                <CollapseHeader isOpen={isOpen} onClick={() => toggleCollapse(courseKey)}>
                    <CardHeader>
                        <CardImage>
                            {!course?.img_url || errorIndexes.includes(index) ? (
                                <StyledNameTag>{nameTag(course?.course_name)}</StyledNameTag>
                            ) : (
                                <StyledImageBox
                                    onError={() => handleImageError(index)}
                                    alt={course?.course_name}
                                    src={course?.img_url}
                                />
                            )}
                        </CardImage>
                        <CardTitle>
                            <StyledCampaignLinkContent>{course.course_name}</StyledCampaignLinkContent>
                        </CardTitle>
                    </CardHeader>
                    <CollapseIcon isOpen={isOpen}>
                        <FeatherIcon icon="chevron-down" size={17} />
                    </CollapseIcon>
                </CollapseHeader>

                {isOpen && (
                    <CollapseContent>
                        {course.email_message && (
                            <MessageSection>
                                <MessageLabel>
                                    <div>Email Message</div>
                                </MessageLabel>

                                <MessageContent
                                    onClick={handleMessageClick}
                                    dangerouslySetInnerHTML={{ __html: course.email_message }}
                                />

                                <ButtonContainer>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Send</Tooltip>}>
                                        <Button
                                            size="xsmall"
                                            buttonStyle="borderless"
                                            onClick={() => sendEmail(course.email_message, course.course_name)}
                                            variant="l3rnTech"
                                        >
                                            <FeatherIcon icon="send" size={17} />
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Copy</Tooltip>}>
                                        <Button
                                            size="xsmall"
                                            buttonStyle="borderless"
                                            onClick={() => copyToClipboard(stripHtmlTags(course.email_message))}
                                            variant="l3rnTech"
                                        >
                                            <FeatherIcon icon="copy" size={17} />
                                        </Button>
                                    </OverlayTrigger>
                                </ButtonContainer>
                            </MessageSection>
                        )}
                        {course.linkedin_message && (
                            <MessageSection>
                                <MessageLabel>
                                    <div>LinkedIn Message</div>
                                </MessageLabel>

                                <MessageContent
                                    onClick={handleMessageClick}
                                    dangerouslySetInnerHTML={{ __html: course.linkedin_message }}
                                />

                                <ButtonContainer>
                                    <OverlayTrigger placement="top" overlay={<Tooltip>Copy</Tooltip>}>
                                        <Button
                                            size="xsmall"
                                            buttonStyle="borderless"
                                            onClick={() => copyToClipboard(stripHtmlTags(course.linkedin_message))}
                                            variant="l3rnTech"
                                        >
                                            <FeatherIcon icon="copy" size={17} />
                                        </Button>
                                    </OverlayTrigger>
                                </ButtonContainer>
                            </MessageSection>
                        )}
                    </CollapseContent>
                )}
            </CollapseCard>
        );
    };

    return (
        <div className="d-flex flex-column w-100 h-100">
            <div style={{ padding: "12px" }}>
                <Tabs
                    options={options}
                    selected={selectedTab}
                    setSelected={(selected) => {
                        setSelectedTab(selected);
                    }}
                />
            </div>
            <ExtensionPopupContentBody>
                {selectedTab === "Course Recommendations" ? (
                    <>
                        {isProfileLoading || gptRecommendationLoading ? (
                            <LoadingContainer>
                                <Spinner size={32} thickness={4} variant="l3rnTech" />
                            </LoadingContainer>
                        ) : gptRecommendationError ? (
                            <ErrorMessage>
                                {gptRecommendationError?.response?.data?.text ||
                                    gptRecommendationError?.message ||
                                    "An error occurred while loading the recommendations. Please try again later."}
                            </ErrorMessage>
                        ) : !gptRecommendation?.recommended_courses ||
                          gptRecommendation.recommended_courses.length === 0 ? (
                            <EmptyStatus description="No recommendations found for this profile." />
                        ) : (
                            gptRecommendation.recommended_courses.map((course, index) =>
                                renderCourseCard(course, index)
                            )
                        )}

                        {/* {selectedTab === "Email Example" && <EmailMessage>{gptRecommendation?.email_message}</EmailMessage>} */}
                    </>
                ) : selectedTab === "New Connections" ? (
                    <ExtensionCainNotifications />
                ) : (
                    <ExtensionAIAgentFeeds />
                )}
            </ExtensionPopupContentBody>
            <StyledFooter>
                <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                        <ExtensionBody>AI Sales Agent</ExtensionBody>
                        <Switch
                            variant="l3rnTech"
                            isActive={aiSalesAgent}
                            onClick={handleSetAiSalesAgent}
                            loading={userSettingsLoading}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Scheduling note: Countries selected after 6:00 PM (MK time) will be applied starting
                                    the next day's run. Countries selected before 6:00 PM will be used in the same
                                    night's run.
                                </Tooltip>
                            }
                        >
                            <FeatherIcon aria-label="x" icon="info" size={20} />
                        </OverlayTrigger>
                        <ButtonWithText
                            buttonStyle="default"
                            variant="l3rnTech"
                            size="xsmall"
                            leftIcon="settings"
                            iconType="feather"
                            onClick={() => setIsModalOpen(true)}
                        >
                            CAIN Targeting
                        </ButtonWithText>
                    </div>
                </div>
            </StyledFooter>
            {isModalOpen && <ExtensionAIAssistantSettings isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
        </div>
    );
};

export default ExtensionAIAssistantPage;
